export enum TipoNota {
	NOTA_ENTRADA = <number>1,
	NOTA_SAIDA = <number>2
}
